module.exports = __webpack_public_path__ + "fonts/OpenSans-BoldItalic.78b08a68.ttf";